// Utility per l'importazione di compagnie assicurative da file JSON, CSV o Excel.
import * as XLSX from "xlsx";


export const COMPAGNIE_JSON_TEMPLATE = [
  {
    nome: "Allianz S.p.A.",
    partita_iva: "05032630963",
    codice_fiscale: "05032630963",
    referente: "Mario Rossi",
    indirizzo: "Piazza Tre Torri 3",
    comune: "Milano",
    provincia: "MI",
    cap: "20145",
    telefono: "02 72161",
    cellulare: "333 1234567",
    email: "info@allianz.example.it",
    pec: "allianz@pec.example.it",
    note: "Compagnia di esempio (template)",
    ispettorati: [
      {
        nome: "Ispettorato Sinistri Sicilia",
        indirizzo: "Via Roma 100",
        comune: "Palermo",
        provincia: "PA",
        telefono: "091 111111",
        email: "sinistri.pa@allianz.example.it",
        referente: "Luca Bianchi",
      },
    ],
    agenzie: [
      {
        nome: "Agenzia Palermo Centro",
        indirizzo: "Via Maqueda 50",
        comune: "Palermo",
        provincia: "PA",
        telefono: "091 222222",
        email: "agenzia.pa@allianz.example.it",
        referente: "Anna Verdi",
      },
    ],
  },
  {
    nome: "Generali Italia S.p.A.",
    partita_iva: "01333550323",
    codice_fiscale: "01333550323",
    referente: "Giulia Neri",
    indirizzo: "Via Marocchesa 14",
    comune: "Mogliano Veneto",
    provincia: "TV",
    cap: "31021",
    telefono: "041 5493111",
    cellulare: "",
    email: "info@generali.example.it",
    pec: "generali@pec.example.it",
    note: "",
    ispettorati: [
      {
        nome: "Ispettorato Sinistri Catania",
        indirizzo: "Corso Italia 200",
        comune: "Catania",
        provincia: "CT",
        telefono: "095 333333",
        email: "sinistri.ct@generali.example.it",
        referente: "Marco Russo",
      },
    ],
    agenzie: [
      {
        nome: "Agenzia Catania Centro",
        indirizzo: "Via Etnea 300",
        comune: "Catania",
        provincia: "CT",
        telefono: "095 444444",
        email: "agenzia.ct@generali.example.it",
        referente: "Sara Costa",
      },
    ],
  },
  {
    nome: "UnipolSai Assicurazioni S.p.A.",
    partita_iva: "00818570012",
    codice_fiscale: "00818570012",
    referente: "Paolo Gallo",
    indirizzo: "Via Stalingrado 45",
    comune: "Bologna",
    provincia: "BO",
    cap: "40128",
    telefono: "051 5077111",
    cellulare: "",
    email: "info@unipolsai.example.it",
    pec: "unipolsai@pec.example.it",
    note: "",
    ispettorati: [
      {
        nome: "Ispettorato Sinistri Messina",
        indirizzo: "Via Garibaldi 10",
        comune: "Messina",
        provincia: "ME",
        telefono: "090 555555",
        email: "sinistri.me@unipolsai.example.it",
        referente: "Elena Ferrara",
      },
    ],
    agenzie: [
      {
        nome: "Agenzia Messina Centro",
        indirizzo: "Viale San Martino 80",
        comune: "Messina",
        provincia: "ME",
        telefono: "090 666666",
        email: "agenzia.me@unipolsai.example.it",
        referente: "Davide Greco",
      },
    ],
  },
];

export function downloadCompagnieTemplate() {
  const blob = new Blob([JSON.stringify(COMPAGNIE_JSON_TEMPLATE, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "template_compagnie.json";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function parseCompagnieJson(text) {
  const data = JSON.parse(text);
  const arr = Array.isArray(data) ? data : Array.isArray(data?.compagnie) ? data.compagnie : null;
  if (!arr) throw new Error("Formato non valido: attesa una lista di compagnie o un oggetto con chiave 'compagnie'.");
  return arr;
}

export function companyName(c) {
  if (!c || typeof c !== "object") return "";
  const norm = {};
  for (const k of Object.keys(c)) {
    const nk = String(k).trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
    if (nk && !(nk in norm)) norm[nk] = c[k];
  }
  const v = norm.nome || norm.denominazione || norm.ragione_sociale || norm.nome_ragione_sociale || "";
  return String(v || "").trim();
}

export function subName(x) {
  return (x?.nome || x?.denominazione || "").trim();
}

export const normName = (s) => (s || "").replace(/\s+/g, " ").trim().toLowerCase();

// --- Excel / CSV ---
const CSV_HEADER = [
  "tipo", "nome", "codice", "partita_iva", "codice_fiscale", "referente", "indirizzo",
  "comune", "provincia", "cap", "telefono", "fax", "cellulare", "email", "pec", "note",
];

export function downloadCompagnieExcelTemplate() {
  const aoa = [CSV_HEADER];
  for (const c of COMPAGNIE_JSON_TEMPLATE) {
    aoa.push(["compagnia", c.nome, c.codice || "", c.partita_iva, c.codice_fiscale, c.referente, c.indirizzo, c.comune, c.provincia, c.cap, c.telefono, c.fax || "", c.cellulare, c.email, c.pec, c.note]);
    for (const i of c.ispettorati || []) aoa.push(["ispettorato", i.nome, "", "", "", i.referente, i.indirizzo, i.comune, i.provincia, i.cap || "", i.telefono, i.fax || "", "", i.email, "", ""]);
    for (const a of c.agenzie || []) aoa.push(["agenzia", a.nome, a.codice_agenzia || "", "", "", a.referente, a.indirizzo, a.comune, a.provincia, a.cap || "", a.telefono, a.fax || "", "", a.email, "", ""]);
  }
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Compagnie");
  XLSX.writeFile(wb, "template_compagnie.xlsx");
}

export async function parseCompagnieSpreadsheet(file) {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array" });
  const ws = wb.Sheets[wb.SheetNames[0]];
  const raw = XLSX.utils.sheet_to_json(ws, { defval: "", raw: false });
  if (!raw.length) throw new Error("Il foglio è vuoto.");
  const rows = raw.map((r) => {
    const o = {};
    for (const k of Object.keys(r)) o[k.trim().toLowerCase()] = String(r[k] ?? "").trim();
    return o;
  });
  const companies = [];
  let current = null;
  for (const r of rows) {
    const tipo = (r.tipo || "").toLowerCase();
    const nome = r.nome || r.denominazione || r.ragione_sociale || "";
    const { tipo: _t, denominazione: _d, ragione_sociale: _rs, ...rest } = r;
    if (tipo === "ispettorato" || tipo === "agenzia") {
      if (!current) continue;
      const sub = {
        ...rest,
        nome, indirizzo: r.indirizzo, comune: r.comune || r.citta, provincia: r.provincia, cap: r.cap,
        telefono: r.telefono || r.tel, fax: r.fax, email: r.email, pec: r.pec,
        referente: r.referente || r.responsabile, note: r.note,
        codice_agenzia: r.codice_agenzia || r.codice || "",
      };
      (tipo === "ispettorato" ? current.ispettorati : current.agenzie).push(sub);
    } else {
      if (!nome) continue;
      current = {
        ...rest,
        nome, codice: r.codice || r.codice_compagnia || "",
        partita_iva: r.partita_iva || r.piva, codice_fiscale: r.codice_fiscale || r.cf,
        referente: r.referente || r.responsabile, indirizzo: r.indirizzo, comune: r.comune || r.citta, provincia: r.provincia,
        cap: r.cap, telefono: r.telefono || r.tel, fax: r.fax, cellulare: r.cellulare || r.cell, email: r.email, pec: r.pec,
        note: r.note, ispettorati: [], agenzie: [],
      };
      companies.push(current);
    }
  }
  if (!companies.length) throw new Error("Nessuna compagnia trovata. Le righe compagnia devono avere tipo 'compagnia' e un nome.");
  return companies;
}

// Legge un file (JSON, CSV o XLSX) e ritorna l'array di compagnie normalizzato.
export async function parseCompagnieFile(file) {
  const name = (file?.name || "").toLowerCase();
  if (name.endsWith(".json")) return parseCompagnieJson(await file.text());
  if (name.endsWith(".csv") || name.endsWith(".xlsx") || name.endsWith(".xls")) return parseCompagnieSpreadsheet(file);
  // fallback: prova JSON
  return parseCompagnieJson(await file.text());
}

